import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-discussion-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './discussion-pagination.component.html',
  styleUrl: './discussion-pagination.component.scss',
})
export class DiscussionPaginationComponent {
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() visible = true;

  @Output() pageChange = new EventEmitter<number>();

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisible = 5;
    const total = this.totalPages;
    if (total <= 0) return pages;

    let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(total, start + maxVisible - 1);
    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.pageChange.emit(page);
  }
}
